module.exports = __webpack_public_path__ + "img/body1.2e562949.png";